// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_d2-0";
export var headerCellHover = "_d2-1";
export var readCellContainer = "_d2-2";
export var unreadIndicator = "_d2-3";